<template></template>
<script>

  import Cookie from 'js-cookie'

  export default {
    mounted() {
      Cookie.remove('access_token')
      Cookie.remove('refresh_token')
      Cookie.remove('admin_access_token')
      Cookie.remove('admin_refresh_token')
      this.$utils.fadeOutLoading()
      this.$router.replace('/')
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/users/Logout.vue